import axios from "axios";
import React, { Component } from "react";
import { toast } from "react-toastify";
import BarTitle from "../../components/BarTitle";
import constants from "../../constants";
import "./styles.css";
import perfilDefault from '../../assets/profile-default.png';


import { Link } from "react-router";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

class RacesHistoric extends Component {
  constructor(props) {
    super(props);

    this.state = {
      racesList: [],
      readyList: true,
    };

    this.cancelSolicitation = this.cancelSolicitation.bind(this);
    this.cancelDirectSolicitation = this.cancelDirectSolicitation.bind(this);
    this.updateHistoric = this.updateHistoric.bind(this);
  }

  componentDidMount() {
    this.updateHistoric();
    this.interval = setInterval(this.updateHistoric, 6000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  formatDate(date) {
    var data = date;
    return data.split(" ")[0];
  }

  updateHistoric() {
    const listRacesUrl =
      constants().URL_SERVICE + `establishment/establishment/list_history/`;

    const customConfig = {
      headers: {
        Authorization: "Token " + localStorage.token,
      },
    };
    try {
      if (this.state.readyList === false) {
        null;
      } else {
        this.setState({ readyList: false });
        axios
          .get(listRacesUrl, customConfig)
          .then((response) => {
            this.setState({ readyList: true });
            delay(200)
            this.setState({ racesList: response.data.services });
          })
      }
    } catch (_err) {
      console.error("Erro: ", _err);
    }
  }

  cancelSolicitation(id) {
    const url =
      constants().URL_SERVICE + "service/requestuser/cancel_service_web/";
    let data = { key: id, is_direct: false };
    try {
      axios
        .post(url, data, {
          headers: { Authorization: "Token " + localStorage.token },
        })
        .then((response) => {
          toast.success("Serviço cancelado com sucesso", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          this.updateHistoric();
          // this.setState({ tableData: response.data.list });
        })
        .catch((error) => {
          this.setState({ error: true });
          toast.error("Ocorreu um Erro Durante o Cancelamento", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        });
    } catch (_err) {
      console.error("Erro: ", _err);
    }
  }

  cancelDirectSolicitation(id, driver_id) {
    const url =
      constants().URL_SERVICE + "service/requestuser/cancel_service_web/";
    let data;
    if (driver_id == null || driver_id == "" || driver_id == 0) {
      data = { key: id, is_direct: false };
    } else {
      data = { key: id, is_direct: true };
    }

    try {
      axios
        .post(url, data, {
          headers: { Authorization: "Token " + localStorage.token },
        })
        .then((response) => {
          toast.success("Serviço cancelado com sucesso", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          this.updateHistoric();
          // this.setState({ tableData: response.data.list });
        })
        .catch((error) => {
          this.setState({ error: true });
          toast.error("Ocorreu um Erro Durante o Cancelamento", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        });
    } catch (_err) {
      console.error("Erro: ", _err);
    }
  }

  render() {
    return (
      <div>
        <BarTitle name="Solicitações" />
        <div className="wrapper-md">
          <div className="panel panel-default">
            <div
              className="panel-heading"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <text>Origem: {localStorage.getItem("address")}</text>
            </div>
            <div className="panel-body">
              <div className="card-main-container">
                {this.state.racesList ? (
                  this.state.racesList.map((service, i) => (
                    <div className="card-main">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                        className="card-title font-bold"
                      >
                        ENTREGA {i + 1}
                        {service.service.status == 1 || service.service.status == 2 ? (
                          service.service.is_direct ? (
                            <label
                              style={{
                                cursor: "pointer",
                                backgroundColor: "#d6d6d6",
                              }}
                              onClick={() => {
                                this.cancelDirectSolicitation(
                                  service.service.key,
                                  service.client.driver_id
                                );
                              }}
                              className="label bg-secondary m-l-xs"
                            >
                              Cancelar
                            </label>
                          ) : (
                            <label
                              style={{
                                cursor: "pointer",
                                backgroundColor: "#d6d6d6",
                              }}
                              onClick={() => {
                                this.cancelSolicitation(service.service.key);
                              }}
                              className="label bg-secondary m-l-xs"
                            >
                              Cancelar
                            </label>
                          )
                        ) : null}
                        {service.service.status == 1 ? (
                          <label className="label bg-warning m-l-xs">
                            Pendente
                          </label>
                        ) : null}
                        {service.service.status == 2 ? (
                          <label className="label bg-success m-l-xs">
                            Aceito
                          </label>
                        ) : null}
                        {service.service.status == 3 ? (
                          <label
                            style={{ backgroundColor: "#00ccff" }}
                            className="label bg-success m-l-xs"
                          >
                            Em atendimento
                          </label>
                        ) : null}
                        {service.service.status == 4 ? (
                          <label className="label bg-info m-l-xs">
                            Finalizado
                          </label>
                        ) : null}
                        {service.service.status == 6 ? (
                          <label className="label bg-danger m-l-xs">
                            Recusado
                          </label>
                        ) : null}
                        {service.service.status == 5 ? (
                          <label className="label bg-danger m-l-xs">
                            Cancelado
                          </label>
                        ) : null}
                      </div>
                      <div className="card-content">
                        <div>
                          <text className="font-bold">Destino: </text>
                          <text>{service.service.arrival_address} </text>
                          <br />
                          <text className="font-bold">KM: </text>
                          <text>
                            {service.service.distance.toFixed(1)} KM{" "}
                          </text>{" "}
                          <br />
                          <text className="font-bold">Valor do Frete: </text>
                          <text> {service.service.price} </text> <br />
                          {service.service.has_return_tax === false ? (
                            <div>
                              <text className="font-bold">Retornar: </text>
                              <text> Não </text> <br />
                            </div>
                          ) : (
                            <div>
                              <text className="font-bold">Retornar: </text>
                              <text> Sim </text>
                              <br />
                            </div>
                          )}
                          {service.service.have_machine == true ? (
                            <div>
                              <text className="font-bold">Maquina: </text>
                              <text> Sim </text> <br />
                            </div>
                          ) : (
                            <div>
                              <text className="font-bold">Maquina: </text>
                              <text> Não </text>
                            </div>
                          )}
                          <text className="font-bold">Observação: </text>
                          <text> {service.service.note} </text> <br />
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          paddingBottom: "2%",
                          borderBottom: "1px solid #dadadb",
                        }}
                      >
                        <div
                          style={{
                            textAlign: "center",
                          }}
                        >
                          <text className="font-bold">Solicitado: </text>
                          <br />
                          <text> {service.service.date} </text>
                          <br />
                          <text> {service.service.hour} </text>
                        </div>
                        <div
                          style={{
                            textAlign: "center",
                          }}
                        >
                          <text className="font-bold">Aceito: </text>
                          <br />
                          {service.service.accepted_time == "" ||
                            service.service.accepted_time == null ? (
                            <div>
                              <text> - </text>
                              <br />
                              <text> - </text>
                            </div>
                          ) : (
                            <div>
                              {this.formatDate(service.service.accepted_time)}
                              <br />
                              <text>
                                {" "}
                                {service.service.accepted_time.match(
                                  /\d{2}([:])\d{2}/g
                                )}{" "}
                              </text>
                            </div>
                          )}
                        </div>
                        <div
                          style={{
                            textAlign: "center",
                          }}
                        >
                          <text className="font-bold">Finalizado: </text>
                          <br />
                          {service.service.finished_time == "" ||
                            service.service.finished_time == null ? (
                            <div>
                              <text> - </text>
                              <br />
                              <text> - </text>
                            </div>
                          ) : (
                            <div>
                              {this.formatDate(service.service.finished_time)}
                              <br />
                              <text>
                                {" "}
                                {service.service.finished_time.match(
                                  /\d{2}([:])\d{2}/g
                                )}{" "}
                              </text>
                            </div>
                          )}
                        </div>
                      </div>
                      {service.client ? (
                        <div className="card-driver-content">
                          <img
                            src={service.client.picture || perfilDefault}
                            width="80"
                            height="80"
                            onError={(e) => {
                              if (e.target.src !== perfilDefault) {
                                e.target.src = perfilDefault;
                              }
                            }}
                            alt="Foto do perfil"
                          />
                          <div className="card-driver-text">
                            <text className="font-bold">ID: </text>
                            <text>{service.client.driver_id}</text> <br />
                            <text className="font-bold">Nome: </text>
                            <text>{service.client.name} </text> <br />
                            <text className="font-bold">Celular: </text>
                            <text>{service.client.phone} </text> <br />
                          </div>
                        </div>
                      ) : (
                        <div className="card-no-driver-content">
                          <text style={{ position: "relative", top: "10px" }}>
                            Corrida sem ID. Estamos procurando um motorista para
                            essa corrida.
                          </text>
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <tr>
                    <td>TESTINHO</td>
                  </tr>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RacesHistoric;



// WEBPACK FOOTER //
// ./src/views/RacesHistoric/index.js